import { Box, Flex, Stack, Text } from '@chakra-ui/layout'
import { Avatar } from '@chakra-ui/avatar'
import { Image } from '@chakra-ui/image'

import { FaWarehouse } from 'react-icons/fa'

import { useParking } from '../../../hooks/useParking'
import { useGeoLocation } from '../../../hooks/useGeoLocation'
import { useGoogleMap } from '../../../hooks/useGoogleMap'

import { MarkerIcon } from '../../../assets/icons/MarkerIcon'

import { ViewType } from '../../../helpers/types/context/googlemap.types'

export function ParkingList() {
  const { parkings } = useParking()
  const { setLocation } = useGeoLocation()
  const { selectMarker, viewType } = useGoogleMap()

  return (
    <Box
      backgroundColor="rgb(255, 255, 255)"
      paddingTop={{
        base: '24px',
      }}
      width="100%"
      height={{
        base: 'calc(100% - 142px)',
        notebook: 'calc(100% - 218px)',
      }}
      position={{
        base: 'absolute',
        notebook: 'static',
      }}
      left="0px"
      zIndex={2}
      overflowY="hidden"
      display={{
        base: `${viewType === ViewType.LIST ? 'block' : 'none'}`,
        notebook: 'block',
      }}
      padding={{
        notebook: '0px',
      }}
    >
      <Box position="relative" overflow="hidden" width="100%" height="100%">
        <Box
          position="absolute"
          inset="0px"
          overflow="scroll"
          marginRight="-15px"
          marginBottom="-15px"
        >
          <Box
            paddingRight={{
              base: '20px',
              notebook: '24px',
            }}
            paddingLeft={{
              base: '16px',
              notebook: '12px',
            }}
          >
            {parkings.map(parking => (
              <Box
                key={parking.id}
                borderBottom="1px solid rgb(215, 215, 224)"
                borderTopColor="rgb(215, 215, 224)"
                borderRightColor="rgb(215, 215, 224)"
                borderLeftColor="rgb(215, 215, 224)"
                marginBottom="20px"
                onClick={() => {
                  const position = {
                    lat: parking.parking_address.latitude,
                    lng: parking.parking_address.longitude,
                  }

                  setLocation(position)
                  selectMarker({
                    id: parking.id,
                    position,
                  })
                }}
              >
                <Flex
                  borderRadius="16px"
                  paddingBottom="24px"
                  cursor="pointer"
                  paddingTop={{ notebook: '12px' }}
                  paddingLeft={{ notebook: '12px' }}
                  paddingRight={{ notebook: '8px' }}
                  transition={{
                    notebook: 'background-color 0.2s ease 0s',
                  }}
                  _hover={{
                    backgroundColor: 'rgb(245, 245, 250)',
                    boxShadow:
                      'rgb(152 152 166 / 20%) 0px 2px 4px -1px, rgb(152 152 166 / 14%) 0px 4px 5px 0px, rgb(152 152 166 / 12%) 0px 1px 10px 0px',
                  }}
                >
                  {/* DIV LOGO */}
                  <Flex
                    borderRadius="8px"
                    backgroundColor="rgb(152, 152, 166)"
                    boxShadow="rgba(152, 152, 166, 0.2) 0px 2px 4px -1px, rgba(152, 152, 166, 0.14) 0px 4px 5px 0px, rgba(152, 152, 166, 0.12) 0px 1px 10px 0px"
                    marginRight="16px"
                    width="48px"
                    height="48px"
                    flexShrink="0"
                    alignItems="center"
                    justifyContent="center"
                    overflow="hidden"
                  >
                    <Image
                      src={parking.picture}
                      alt={parking.name}
                      background="parkoff.orange.300"
                      width="100%"
                      height="100%"
                    />
                  </Flex>
                  {/* DIV INFORMAÇÕES DO ESTACIONAMENTO */}
                  <Box>
                    <Text
                      margin="0px 0px 4px"
                      padding="0px"
                      fontSize="16px"
                      fontWeight="700"
                      color="rgb(35, 27, 34)"
                    >
                      {parking.name}
                    </Text>
                    <Flex marginBottom="4px" alignItems="center">
                      <Box marginRight="4px" flexShrink={0}>
                        <MarkerIcon
                          width="12px"
                          height="12px"
                          fill="rgb(35, 27, 34)"
                        />
                      </Box>
                      <Text
                        margin="0px"
                        padding="0px"
                        fontSize="14px"
                        lineHeight="20px"
                        fontWeight="500"
                        color="rgb(35, 27, 34)"
                      >
                        {`${parking.parking_address.distance} • ${parking.parking_business_hours[0].hour_start_formatted} - ${parking.parking_business_hours[0].hour_end_formatted}`}
                      </Text>
                    </Flex>
                    <Flex marginBottom="4px" alignItems="center">
                      <Box marginRight="4px" flexShrink={0}>
                        <Image
                          src="https://parkoff-prod.s3.us-east-2.amazonaws.com/assets/svg/money.svg"
                          width="12px"
                          height="12px"
                          color="rgb(35, 27, 34)"
                        />
                      </Box>
                      <Text
                        margin="0px"
                        padding="0px"
                        fontSize="14px"
                        lineHeight="20px"
                        fontWeight="500"
                        color="rgb(35, 27, 34)"
                      >
                        {parking.parking_configurations.hour_price_formatted}
                      </Text>
                    </Flex>
                    <Text
                      margin="0px 0px 4px"
                      padding="0px"
                      fontSize="14px"
                      lineHeight="20px"
                      fontWeight="500"
                      color="rgb(35, 27, 34)"
                    >
                      {parking.parking_characteristics_formatted}
                    </Text>
                    <Stack
                      spacing="5px"
                      direction={{ base: 'column', mobileMedium: 'row' }}
                      marginRight={{
                        base: '10px',
                        notebook: '0px',
                      }}
                    >
                      {parking.parking_configurations.allow_scheduling && (
                        <Box
                          display="inline-flex"
                          justifyContent="center"
                          alignItems="center"
                          borderStyle="solid"
                          padding="0px 4px"
                          backgroundColor="#3CAE92"
                          color="white"
                          borderRadius="4px"
                          borderWidth="1px"
                          borderColor="#3CAE92"
                          fontSize="12px"
                          lineHeight="16px"
                          fontWeight="700"
                        >
                          Permite Agendamento
                        </Box>
                      )}
                      {parking.parking_configurations.premium && (
                        <Box
                          display="inline-flex"
                          justifyContent="center"
                          alignItems="center"
                          borderStyle="solid"
                          padding="0px 4px"
                          backgroundColor="orange.400"
                          color="white"
                          borderRadius="4px"
                          borderWidth="1px"
                          borderColor="orange.400"
                          fontSize="12px"
                          lineHeight="16px"
                          fontWeight="semibold"
                        >
                          VIP
                        </Box>
                      )}
                    </Stack>
                  </Box>
                </Flex>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
